import React from "react";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { getRequest, postRequest } from "sharedUtils/httpUtils";
import MUIDataTable from "mui-datatables";
import TextField from '@material-ui/core/TextField';
import AffiliateCommissionData from './AffiliateCommissionData';
import AffiliateCommissionRawData from './AffiliateCommissionRawData';
import { convertToNumericMonthAndDayAndYearAndTime } from "sharedUtils/timeUtils";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import { CheckIconBlack } from "../../icons";
import PenIcon from "components/icons/PenIcon";
import { getQueryStringParams, showBrandNav } from "sharedUtils/navUtils"

const { DateTime } = require("luxon");

class AffiliateCommissionDetails extends React.Component {
    constructor(props) {
        super(props);
        this.tableRef = React.createRef();

        this.state = {
            startDate: DateTime.utc().minus({ months: 1 }).startOf('day'),
            endDate: DateTime.utc().endOf('day'),
            minDate: "1753-01-01",
            maxDate: "9999-12-31",
            dateError: false,
            tab: 0,
            affiliateProgramManager: null,
            apmId: this.props.apmId ?? null,
            affiliateCommissionId: this.props.location?.state?.["affiliateCommissionId"]
                ? this.props.location.state["affiliateCommissionId"] 
                : "",
        }
    }

    componentDidMount = () => {
        window.scrollTo({ left: 0, top: 0, behavior: 'auto' });
        const affiliateCommissionId = getQueryStringParams(window.location.search).id;
        if (affiliateCommissionId) {
            this.setState({ affiliateCommissionId })
        }
        this.fetchAffiliateProgramManager();

        if (this.props.history) {
            this.props.history.replace({
                ...this.props.location,
                state: {}
            });
        }
    };


    handleStartDateChange = (event) => {
        const startDateRaw = event.target.value;
        if (startDateRaw.length === 0) return;

        const startDate = DateTime.fromISO(startDateRaw).toUTC().startOf('day');
        if (startDate.isValid) {
            this.setState({ startDate });
        } else {
            console.error("Invalid start date entered:", startDateRaw);
        }
    };

    handleEndDateChange = (event) => {
        const endDateRaw = event.target.value;
        if (endDateRaw.length === 0) return;

        const endDate = DateTime.fromISO(endDateRaw).toUTC().endOf('day');
        if (endDate.isValid) {
            this.setState({ endDate });
        } else {
            console.error("Invalid end date entered:", endDateRaw);
        }
    };

    handleWeekToDate = () => {
        const startDate = DateTime.utc().minus({ weeks: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().endOf('day') });
    };

    handleMonthToDate = () => {
        const startDate = DateTime.utc().minus({ months: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().endOf('day') });
    };

    handleYearToDate = () => {
        const startDate = DateTime.utc().minus({ years: 1 }).startOf('day');
        this.setState({ startDate, endDate: DateTime.utc().endOf('day') });
    };

    fetchAffiliateProgramManager = async (id) => {
        let url = `api/AffiliateProgramManager/GetAffiliateProgramManager?id=${this.state.apmId}`;
        let affiliateProgramManager = await getRequest(url);
        if (affiliateProgramManager) {
            this.setState({ affiliateProgramManager })
        }
    }

    onInputChange = (e) => {
        let affiliateCommissionId = e.target.value;

        this.setState({ affiliateCommissionId  });
    };


    onTabChange = (tab) => {
        this.setState({ tab });
    }

    render() {
        let smallSizes = ["sm", "md"];
        let { deviceSize } = this.props;
        
        return (
            <div style={{ display: this.props.display ? "" : "none" }}>

                <section className="gray-bg mb-0 pt-0" style={{ display: this.state.tab === 1 ? "" : "none" }}>
                    {
                        !["sm"].includes(this.props.deviceSize) ?
                            <></>
                            :
                            <div className="d-flex w-100 justify-content-end pr-2" style={{ fontFamily: "'Archivo', sans-serif" }}>
                                <div onClick={this.handleWeekToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '4px 0 0 4px' }}>1w</div>
                                <div onClick={this.handleMonthToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', borderTop: '1px solid lightgray', borderBottom: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>1m</div>
                                <div onClick={this.handleYearToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '0 4px 4px 0' }}>1y</div>
                            </div>
                    }
                    <p className="ml-5 pt-3 mb-0" style={{ color: "red", display: this.state.dateError ? "" : "none" }}>Dates must be valid dates and Start Date must be before the End Date </p>

                    <div className="pt-0 pb-0 px-5">

                        <div className={`mx-0 d-flex justify-content-between pb-4 ${["sm"].includes(this.props.deviceSize) ? "ml-2 mr-2" : "pt-0"} mx-auto`}>

                            <div className={`d-flex ${["sm"].includes(this.props.deviceSize) ? "w-100 pt-3 mx-2" : ""} justify-content-${["sm"].includes(this.props.deviceSize) ? "between" : "start"}`} style={{ gap: ["sm"].includes(this.props.deviceSize) ? "" : "30px", fontFamily: "'Archivo',sans-serif" }}>

                                <div className="d-flex flex-column">
                                    <label className="mb-0">CreatedDate Start:</label>
                                    <TextField
                                        id="start-date"
                                        type="date"
                                        value={this.state.startDate.toISODate()}
                                        onChange={this.handleStartDateChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            style: { fontFamily: "'Archivo', sans-serif" },
                                        }} />
                                </div>
                                <div className="d-flex flex-column">
                                    <label className="mb-0">CreatedDate End:</label>
                                    <TextField
                                        id="end-date"
                                        type="date"
                                        value={this.state.endDate.toISODate()}
                                        onChange={this.handleEndDateChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        InputProps={{
                                            style: { fontFamily: "'Archivo', sans-serif" },
                                        }}
                                    />
                                </div>
                            </div>
                            {
                                ["sm"].includes(this.props.deviceSize) ?
                                    <></>
                                    :
                                    <div className="d-flex" style={{ fontFamily: "'Archivo', sans-serif" }}>
                                        <div onClick={this.handleWeekToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '4px 0 0 4px' }}>1w</div>
                                        <div onClick={this.handleMonthToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', borderTop: '1px solid lightgray', borderBottom: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>1m</div>
                                        <div onClick={this.handleYearToDate} style={{ cursor: "pointer", width: '35px', height: '35px', backgroundColor: 'white', border: '1px solid lightgray', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '0 4px 4px 0' }}>1y</div>
                                    </div>
                            }

                        </div>
                    </div>

                </section>

                <section>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col position-relative">
                                <ul className={`nav nav-tabs justify-content-end ${smallSizes.includes(deviceSize) ? "pt-5" : ""}`}>
                                    <li className={`nav-item ${smallSizes.includes(deviceSize) ? "my-products-tab-ul-small" : ""} `} onClick={() => this.onTabChange(0)}>
                                        <span className={`nav-link text-center ${smallSizes.includes(deviceSize) && this.state.tab === 0 ? "my-products-tab-small-active" : smallSizes.includes(deviceSize) ? "my-products-tab-small" : this.state.tab === 0 ? "my-products-tab-active" : "my-products-tab"}`}>{this.state.affiliateProgramManager?.name + " Commission Data"}</span>
                                    </li>
                                    <li className={`nav-item ${smallSizes.includes(deviceSize) ? "my-products-tab-ul-small" : ""} `} onClick={() => this.onTabChange(1)}>
                                        <span className={`nav-link text-center ${smallSizes.includes(deviceSize) && this.state.tab === 1 ? "my-products-tab-small-active" : smallSizes.includes(deviceSize) ? "my-products-tab-small" : this.state.tab === 1 ? "my-products-tab-active" : "my-products-tab"}`}>{this.state.affiliateProgramManager?.name + " Commission History JSON"}</span>
                                    </li>
                                </ul>
                                {
                                    this.state.affiliateProgramManager ?
                                        <>
                                            <div
                                                className="search-interest pt-1 mx-auto position-absolute"
                                                style={{ left: "15px", top: "-15px", display: this.state.tab === 0 ? "" : "none" }}
                                            >
                                                <div className="search-block d-md-flex justify-content-between">
                                                    <div
                                                        className={`form-group position-relative ${["sm", "md"].includes(this.state.deviceSize) ? "mx-auto" : ""
                                                            } d-md-flex justify-content-center`}
                                                        style={{ width: "380px" }}
                                                    >
                                                        <input
                                                            type="search"
                                                            id="gsearch"
                                                            name="gsearch"
                                                            placeholder="Paste affiliate commission ID..."
                                                            value={this.state.affiliateCommissionId}
                                                            onChange={(e) => this.onInputChange(e)}
                                                            className="form-control"
                                                            style={{ paddingLeft: "25px" }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                            {
                                                this.state.tab === 0 ?
                                                    <AffiliateCommissionData affiliateProgramManager={this.state.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.state.affiliateCommissionId ?? ""} deviceSize={this.props.deviceSize} />
                                                        :
                                                    <AffiliateCommissionRawData startDate={this.state.startDate} endDate={this.state.endDate} affiliateProgramManager={this.state.affiliateProgramManager} loggedInUser={this.props.loggedInUser} affiliateCommissionId={this.state.affiliateCommissionId ?? ""} />
                                            }
                                        </>
                                        :
                                        <></>
                                }

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default withRouter(AffiliateCommissionDetails);